/* eslint-disable indent */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { memo, useMemo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { AddWhite, filterIcon, toggleOff, toggleOn } from '../../assets/icons';
import Table from './Table';
import DynamicSVGIcon from '../../component/Common/DynamicSVGIcon';
import { Data } from './data';

import {
  ChildDetail,
  CompletedStepsData,
  Container,
  CreateBttn,
  CreatedByData,
  EquipmentData,
  Filetrcont,
  FilterBtn,
  HeaderText,
  HeadingBox,
  HeadingContainer,
  Step,
  WOBody,
  WODetailedContainer,
  WODetailText,
  WOIdContainer,
  WOIdText,
  WOLabelText,
  WoLeft,
  WoRight,
  WorkOrderContainer
} from './WorkOrders.styles';
import Createworkorder from '../../component/WorkOrder/CreateWorkOrder/CreateWorkorder';
import { Div, FlexContainer } from '../../globalStyles';
import { DropdownComponent, InputComponent } from '../../component';
import { AlignedDiv } from '../../component/Common/CommonStyles';
import DropArrow from '../../assets/icons/layout/dropdownarrow.svg';
import { WorkOrderCreators } from './store';
import { WO_CREATION_FROM, WO_TYPES } from '../../constants';
import useGetWorkOrderTypes from '../../component/WorkOrder/CreateWorkOrder/hooks/useGetWorkOrderTypes';
import Loader from '../../component/Loader/Loader';
import Pagination from '../../component/Common/Pagination/Pagination.view';
import Toast from '../../component/Common/Toast';
import { apiEndPoints } from '../../services/axios/endPoints';
import { isEmpty } from '../../shared/utility/isEmpty';
import { useActions } from '../../store/hooks/useActions';
import PaginationWithPage from '../../component/Common/Pagination/PaginationWithPage.view';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';
import { getStringLocale } from '../../constants/language';
import WOFilter from '../../component/WorkOrder/WoFilters/WOFilter';
import FilterMobileIcon from '../../assets/icons/Filter/Filters white.svg';

const WorkOrdersList = ({
  menuId,
  type,
  setType,
  withFilter = true,
  filteredWorkOrders
}) => {
  const { localeStrings } = useSelector((state) => state.localeStrings);
  const { workOrders, woCount, loading, error, woHeaders, woSearchQueries } =
    useSelector((state) => state.workOrders);
  const [filters, setFilters] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  useEffect(() => {
    const filtered = woHeaders?.filter(
      (item) =>
        // item.searchable === true ||
        Array.isArray(item.options) && item.options.length > 0
    );
    const searchable = woHeaders?.filter(
      (item) =>
        item.searchable === true &&
        Array.isArray(item.options) &&
        !item.options.length > 0 &&
        item?.type !== 'DateTime'
    );
    setFilters({ filtered, searchable });
  }, [woHeaders]);

  const { setWorkOrderDetail, setWorkOrderSearchQueries, setSelectedFilters } =
    useActions();
  const [showCreate, setShowCreate] = useState(false);
  // const [collapse, setCollapse] = useState(false);
  const pageSize = 20;

  const dispatch = useDispatch();
  useGetWorkOrderTypes();
  const handlePageChange = (page, rest = {}) => {
    const { searchParams } = rest;
    let endpoint = apiEndPoints.getWorkOrders;
    if (!withFilter) {
      endpoint = apiEndPoints.getWorkOrdersWithoutUserFilter;
    }
    dispatch(
      WorkOrderCreators.getWorkOrders({
        page,
        pageSize,
        type,
        endpoint,
        searchParams
      })
    );
  };
  const navigate = useNavigate();
  const location = useLocation();

  const handleDetails = (jobOrderId, type) => {
    navigate(`/home/work_orders/${type}/${jobOrderId}`, {
      state: { previousLocation: location.pathname }
    });
  };

  const clearToastMessage = () => {
    if (error) dispatch(WorkOrderCreators.getWorkOrdersFailure({ error: '' }));
  };

  useEffect(() => {
    dispatch(WorkOrderCreators.resetWorkOrderDetails());
    handlePageChange(1);

    return () => {
      dispatch(WorkOrderCreators.resetWorkOrderSearchQueries());
      setSelectedFilters({});
    };
  }, []);

  const { userData } = useSelector((state) => state.loginData);
  const { finalMenu } = useSelector((state) => state.home);

  useEffect(() => {
    const name = finalMenu.find((ele) => ele.path === location.pathname);
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
  }, []);

  const handleCreateWO = () => {
    // dispatch(
    //   UpsertWOCreators.setWorkOrderDetail({
    //     key: 'workOrderCreationFrom',
    //     value: WO_CREATION_FROM.WORK_ORDERS_LIST
    //   })
    // );
    setWorkOrderDetail({
      workOrderCreationFrom: WO_CREATION_FROM.WORK_ORDERS_LIST
    });
    setShowCreate(true);
  };

  const handleFilterClick = () => {
    setShowFilters(true);
  };

  const showCollapse = !isEmpty(workOrders)
    ? workOrders.some((woItem) => woItem.child?.length > 1)
    : false;

  const renderWo = (wo) => {
    const StepsRequired = wo?.next_avaialable_steps_altText?.split(',');
    const allSteps = StepsRequired && [
      wo?.current_state_completed_text,
      ...StepsRequired
    ];

    return (
      <WorkOrderContainer
        onClick={() => {
          handleDetails(wo?.jobOrderId, wo?.type);
        }}
      >
        <WOIdContainer>
          <WoLeft>
            <WOIdText>{wo?.jobOrderId}</WOIdText>
          </WoLeft>
          <WoRight>
            <WOLabelText>{getStringLocale('Created on', 'en')}</WOLabelText>
            <WODetailText>{wo?.createdDate}</WODetailText>
          </WoRight>
        </WOIdContainer>
        <WODetailedContainer>
          <CreatedByData>
            <WOLabelText>{getStringLocale('Created By', 'en')}</WOLabelText>
            <WODetailText className='highlighted'>
              {wo?.createdBy || '-'}
            </WODetailText>
          </CreatedByData>
          {wo?.EquipmentNo && !wo?.fromLocation && !wo?.toLocation && (
            <EquipmentData>
              <WOLabelText>{getStringLocale('Equipment No', 'en')}</WOLabelText>
              <WODetailText className='highlighted'>
                {wo?.EquipmentNo}
              </WODetailText>
            </EquipmentData>
          )}
          {wo?.fromLocation && wo?.toLocation && (
            <EquipmentData>
              <WOLabelText>{getStringLocale('From - To', 'en')}</WOLabelText>
              <WODetailText className='highlighted'>
                {`${wo?.fromLocation} -> ${wo?.toLocation}`}
              </WODetailText>
            </EquipmentData>
          )}
        </WODetailedContainer>
        <CompletedStepsData>
          {allSteps?.map((step, index) => (
            <Step
              key={index}
              active={index === 0}
              index={index}
              isEven={index % 2 === 0}
            >
              {step}
            </Step>
          ))}
        </CompletedStepsData>
      </WorkOrderContainer>
    );
  };

  return (
    <>
      {showCreate && (
        <Createworkorder
          menuId={menuId}
          onCancel={() => setShowCreate(false)}
        />
      )}
      {showFilters && (
        <WOFilter
          onCancel={() => setShowFilters(false)}
          filters={filters}
          workOrders={workOrders}
          handlePageChange={handlePageChange}
          setSearchQueries={setWorkOrderSearchQueries}
        />
      )}
      <Container style={{ position: 'relative' }}>
        <HeadingContainer>
          <HeadingBox>
            {type ? (
              <>
                <AlignedDiv>
                  <div
                    onClick={() => setType('')}
                    style={{ paddingRight: '1rem' }}
                  >
                    <DynamicSVGIcon iconUrl={DropArrow} width='1.5rem' />
                  </div>
                  <HeaderText>{getStringLocale(type)}</HeaderText>
                </AlignedDiv>
              </>
            ) : (
              <HeaderText>
                {localeStrings['Work Orders'] ||
                  getStringLocale('Work Orders', 'en')}
              </HeaderText>
            )}
          </HeadingBox>
          <FlexContainer className='ai_center'>
            {/* {!type && (
              <CreateBttn className='flex ai_center' onClick={handleCreateWO}>
                <DynamicSVGIcon iconUrl={AddWhite} width='10px' />
                Create Work Order
              </CreateBttn>
            )} */}
            {/* {showCollapse && (
              <FlexContainer
                style={{ marginLeft: '2rem' }}
                className='ai_center pointer'
                onClick={() => setCollapse(!collapse)}
              >
                <p style={{ fontSize: '12px', marginRight: '5px' }}>Collapse</p>
                {collapse ? (
                  <DynamicSVGIcon iconUrl={toggleOn} width='42px' />
                ) : (
                  <DynamicSVGIcon iconUrl={toggleOff} width='42px' />
                )}
              </FlexContainer>
            )} */}
          </FlexContainer>
        </HeadingContainer>
        {loading ? (
          <Loader className='position' />
        ) : (
          <WOBody>
            {workOrders?.map((wo, index) => (
              <React.Fragment key={wo?.jobOrderId || index}>
                {renderWo(wo)}
                {wo?.child?.length > 0 &&
                  wo.child.map((child, cIndex) => (
                    <ChildDetail key={child?.jobOrderId || cIndex}>
                      {renderWo(child)}
                    </ChildDetail>
                  ))}
              </React.Fragment>
            ))}
          </WOBody>
        )}
        {!type && (
          <CreateBttn className='flex ai_center' onClick={handleCreateWO}>
            <DynamicSVGIcon iconUrl={AddWhite} width='20px' />
          </CreateBttn>
        )}
        <FilterBtn className='flex ai_center' onClick={handleFilterClick}>
          <DynamicSVGIcon iconUrl={FilterMobileIcon} width='15px' />
        </FilterBtn>
        {error && (
          <Toast
            style={{ right: 20 }}
            fn={clearToastMessage}
            header='Error'
            message={error}
          />
        )}
      </Container>
      <div
        style={{
          width: '95vw',
          display: 'flex',
          justifyContent: 'flex-start',
          marginBottom: '1rem',
          padding: '1rem 1rem',
          overflowX: 'auto'
        }}
      >
        <PaginationWithPage
          ItemsPerPage={pageSize}
          total={woCount}
          handlePageChange={handlePageChange}
          searchParams={woSearchQueries}
          isLoading={loading}
        />
      </div>
    </>
  );
};

export default memo(WorkOrdersList);
